import axios from "axios";

/** Même origine en prod (nginx /api) si la variable n'est pas définie au build. */
function resolveBackendUrl() {
  const fromEnv = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/$/, "");
  if (fromEnv) return fromEnv;
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "";
}

const BACKEND_URL = resolveBackendUrl();
export const API_BASE = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatApiError(error) {
  const detail = formatApiErrorDetail(error?.response?.data?.detail);
  if (detail) return detail;
  if (error?.response?.status === 422) return "Vérifiez email, mot de passe (6 caractères min.) et nom (2 caractères min.).";
  if (error?.response?.status) return `Erreur serveur (${error.response.status}).`;
  if (error?.request && !error?.response) {
    return "Impossible de joindre le serveur. Vérifiez votre connexion.";
  }
  return error?.message || "Une erreur est survenue.";
}

export function wsUrl(roomId, token) {
  const httpUrl = BACKEND_URL || (typeof window !== "undefined" ? window.location.origin : "");
  const wsScheme = httpUrl.startsWith("https") ? "wss" : "ws";
  const host = httpUrl.replace(/^https?:\/\//, "");
  const base = `${wsScheme}://${host}/api/ws/games/${roomId}`;
  if (!token) return base;
  return `${base}?token=${encodeURIComponent(token)}`;
}

/** Token court pour authentifier le WebSocket (cookie httpOnly non lisible en JS). */
export async function fetchWsToken() {
  const { data } = await api.get("/auth/ws-token");
  return data?.token || "";
}
